module.exports = __webpack_public_path__ + "img/newicon1click.739e1b00.svg";